import { getExceptionFromAxiosError } from '@/client/helpers';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import {
  FalsePositiveIp,
  FalsePositiveIpsResponse,
  UpdateFalsePositiveIpsRequest,
} from './types/false-positive-ips.type';

export const falsePositiveIpsService = (client: AxiosInstance) => {
  const BASE_URL = '/gophish/settings/false-positive-ips';

  const getFalsePositiveIps = async (): Promise<FalsePositiveIpsResponse> => {
    try {
      const result = await client.get<
        FalsePositiveIpsResponse,
        AxiosResponse<FalsePositiveIpsResponse>
      >(BASE_URL, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const updateFalsePositiveIpsList = async (
    request: UpdateFalsePositiveIpsRequest,
  ): Promise<FalsePositiveIp> => {
    try {
      const result = await client.put<
        FalsePositiveIp,
        AxiosResponse<FalsePositiveIp>
      >(BASE_URL, request, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  return {
    getFalsePositiveIps,
    updateFalsePositiveIpsList,
  };
};
